import AOS from 'aos';

const reloadAlert = () => {
  const alertNode = $('#js-alert-notice')[0]
  if (alertNode) {
    $(alertNode).delay(5000).fadeTo(2000, 0)
  }
}

// Инициализация Yandex API
window.initializeYandexApi = async function (launchNumber = 0) {
  if (typeof ymaps == 'undefined') {
    var script = document.createElement('script');

    script.src = `https://api-maps.yandex.ru/2.1/?lang=ru-RU&apikey=${$('d8hy7').html()}`;
    document.body.appendChild(script);
  }
  while (typeof ymaps == 'undefined') {
      await new Promise(r => setTimeout(r, 2000));
    }
  return new Promise(resolve => resolve(`Yandex API подключен`))
}

//
const initializeYandexGeolocation = () => {
  geolocationInit();
}

// Поиск по DOM элементов, для которых необходима инициализация Yandex Map
window.checkMapInitialize = () => {
  var mapNodes = document.querySelectorAll('[data-map]:empty');

  if (mapNodes.length) {
    for (let i = 0; i < mapNodes.length; i++) {
      initializeYandexMap(mapNodes[i])
    }
  }
}

window.safeMapInit = (mapId) => { if (typeof(mapInit) === "undefined") return; mapInit(mapId)}

// Инициализация Yandex Map
window.initializeYandexMap = (mapNode) => {
  var mapId = $(mapNode).attr('id');
  ymaps.ready(safeMapInit(mapId));
}

$(document).on('turbo:load', () => {
  reloadAlert()

  // INITIALIZATION OF AOS
  AOS.init({
    duration: 650,
    once: true
  });
  initializeYandexApi()
      .then(() => {
        checkMapInitialize();
        initializeYandexGeolocation()
      })
      .catch((message) => {
        console.log(message)
      })
})

window.turbo_reload = function(event) {
  const ublockId = event.currentTarget.dataset.ublock;
  const ublockRoute = event.currentTarget.dataset.ublockroute;
  const parentId = event.currentTarget.dataset.ublockparent;
  const relationId = event.currentTarget.dataset.relation;
  const frameId = event.currentTarget.dataset.turbosrc;
  const type = event.currentTarget.dataset.ublocktype;
  const frame = document.getElementById(frameId);

  frame.innerHTML = '';
  if (parentId)
    frame.src = `/ublocks/new?route_id=${ublockRoute}&parent_id=${parentId}${
                             relationId ? `&relation_id=${relationId}` : ''}${
                             type ? `&type=${type}` : ''}`;
  else
    frame.src = `/ublocks/${ublockId}/edit?route_id=${ublockRoute}${relationId ? `&relation_id=${relationId}` : ''}`;
}